import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "MVVM/Hooks/useUser";

const PRO_EDIT_STORAGE_KEY = "pro_edit_enabled";

export const useProEditAccess = () => {
  const { allstarUser } = useUser();
  const location = useLocation();
  const [hasProEditParam, setHasProEditParam] = useState(() => {
    return localStorage.getItem(PRO_EDIT_STORAGE_KEY) === "true";
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get("pro_edit") === "true") {
      localStorage.setItem(PRO_EDIT_STORAGE_KEY, "true");
      setHasProEditParam(true);
    }
  }, [location.search]);

  const userGroupType = allstarUser?.user?.userGroup?.type;
  const hasValidUserGroup =
    userGroupType === "INTERNAL" || userGroupType === "CREATOR_PLAT";

  const hasProEditAccess = hasValidUserGroup && hasProEditParam;

  return {
    hasProEditAccess,
    hasValidUserGroup,
    hasProEditParam,
  };
};
